import { render, staticRenderFns } from "./select-status.vue?vue&type=template&id=168ff91c&lang=pug&"
import script from "./select-status.vue?vue&type=script&lang=ts&"
export * from "./select-status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports